import React from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '../../../../../hooks/useTheme';

export const TableActions = props => {
    const { id, status, shop_id } = props;

    const navigate = useNavigate();
    const { colorIcon } = useTheme();

    const openSetting = shopId => {
        return navigate(`${shopId}`);
    };

    return (
        <div onClick={() => openSetting(id)}>
            <SettingOutlined
                style={{
                    cursor: 'pointer',
                    color: colorIcon,
                    fontSize: 20,
                }}
            />
        </div>
    );
};
